import {
  createAdmin,
  createRole,
  deleteAdmin,
  deleteRole,
  getAdminList,
  getRoleList,
  updateAdminStatus,
  updateRole,
  updateRoles,
  updateRolesQ,
  updateRoleStatus,
} from "@/api/modules/roleManagement";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getRoleListAction = createAsyncThunk(
  "roleManagement/getRoleList",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getRoleList(params);

    return result.data;
  }
);

export const getAdminListAction = createAsyncThunk(
  "roleManagement/getAdminList",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getAdminList(params);

    return result.data;
  }
);

export const updateRoleStatusAction = createAsyncThunk(
  "roleManagement/updateRoleStatus",
  async ({ id, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await updateRoleStatus(id, params);
    return result.data;
  }
);

export const updateAdminStatusAction = createAsyncThunk(
  "roleManagement/updateAdminStatus",
  async ({ id, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await updateAdminStatus(id, params);
    return result.data;
  }
);

export const createRoleAction = createAsyncThunk(
  "roleManagement/createRole",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await createRole(params);

    return result.data;
  }
);

export const createAdminAction = createAsyncThunk(
  "roleManagement/createAdmin",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await createAdmin(params);

    return result.data;
  }
);

export const deleteAdminAction = createAsyncThunk(
  "roleManagement/deleteAdmin",
  async (id: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await deleteAdmin(id);

    return result.data;
  }
);

export const deleteRoleAction = createAsyncThunk(
  "roleManagement/deleteRole",
  async (id: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await deleteRole(id);

    return result.data;
  }
);

export const updateRoleAction = createAsyncThunk(
  "roleManagement/updateRole",
  async ({ id, data }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await updateRole(id, data);

    return result.data;
  }
);

export const updateRolesAction = createAsyncThunk(
  "roleManagement/updateRoles",
  async ({ id, data }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await updateRoles(id, data);

    return result.data;
  }
);

export const updateRolesQAction = createAsyncThunk(
  "roleManagement/updateRolesQ",
  async ({ roleId, data }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await updateRolesQ(roleId, data);

    return result.data;
  }
);
